export const brandInfo = {
  name: "91吃瓜网",
  fullName: "91吃瓜网 - 吃瓜群众的必刷入口",
  founded: "2020",
  description: "91吃瓜网是国内领先的娱乐八卦资讯平台，致力于为吃瓜群众提供最新、最全、最热的娱乐圈爆料、网红黑料和明星塌房资讯。我们秉持真实、快速、全面的原则，第一时间追踪网红明星最新动态，每日更新热门视频和话题，让每一位吃瓜群众都能在这里找到最想看的八卦内容。",
  reputation: "自2020年上线以来，91吃瓜网已累计服务超过5000万吃瓜群众，日均活跃用户突破300万，累计发布爆料资讯超过10万条。平台以独家爆料和深度追踪闻名，多次率先曝光娱乐圈重大事件，成为吃瓜圈公认的头部平台。",
  contact: {
    email: "tips@91chigua.com",
    wechat: "chigua91official",
    weibo: "@91吃瓜网官方",
    address: "北京市朝阳区吃瓜路91号",
  },
  stats: [
    { value: "5000万+", label: "累计用户" },
    { value: "300万+", label: "日活用户" },
    { value: "10万+", label: "爆料资讯" },
    { value: "1000+", label: "独家爆料" },
  ],
};

export const faqList = [
  {
    question: "91吃瓜网的信息来源是什么？",
    answer: "我们的信息来源包括网友投稿、业内人士爆料、社交媒体公开信息以及专业团队追踪整理。所有信息均会标注来源，确保内容可追溯。",
  },
  {
    question: "如何向91吃瓜网投稿爆料？",
    answer: "您可以通过邮箱 tips@91chigua.com 或微信公众号 chigua91official 向我们投稿。我们会对投稿内容进行核实，确认属实后发布并给予爆料者相应奖励。",
  },
  {
    question: "91吃瓜网的内容是否真实可靠？",
    answer: "我们建立了严格的内容审核机制，所有爆料内容均会经过多方核实后再发布。对于未经证实的传闻，我们会明确标注'待核实'状态，让读者自行判断。",
  },
  {
    question: "如何在91吃瓜网上找到感兴趣的内容？",
    answer: "您可以通过首页的分类导航浏览不同频道的内容，也可以使用搜索功能查找特定话题。我们的内容按网红黑料、明星塌房、每日大赛、娱乐八卦、社会热点等分类整理。",
  },
  {
    question: "91吃瓜网的更新频率是怎样的？",
    answer: "我们实行7×24小时全天候更新机制，热点事件发生后30分钟内即可发布相关报道。每日凌晨定时更新当日热点汇总，确保您不错过任何大瓜。",
  },
];